if (!customElements.get('star-b-pairing')) {
  customElements.define('star-b-pairing', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.animations = new Set();
      this.previousCount = null;
      this.previousTotal = null;
      this.items = [...this.querySelectorAll('[data-item]')];
      this.addButton = this.querySelector('[data-add]');
      this.status = this.querySelector('[data-status]');
      this.currency = this.dataset.currency || 'USD';
      this.busy = false;
      this.mainAvailable = true;
      this.seenTwenty = false;
      this.toastTimer = null;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motion = !this.motionQuery.matches;
      this.motionQuery.addEventListener('change', event => {
        this.motion = !event.matches;
        if (!this.motion) {
          this.animations.forEach(animation => animation.cancel());
          this.querySelectorAll('.star-b__stars').forEach(node => node.remove());
        }
      });
      document.querySelectorAll('.star-b-jump[href="#star-b-pairing"]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        this.scrollIntoView({ behavior: this.motion ? 'smooth' : 'instant', block: 'start' });
        this.querySelector('.star-b__intro h2')?.focus({ preventScroll: true });
      }));
      this.items.forEach(item => {
        if (!item.hasAttribute('data-main')) {
          item.querySelector('[data-select]')?.addEventListener('change', () => this.toggle(item));
          item.addEventListener('click', event => {
            if (event.target.closest('button,input,dialog')) return;
            this.toggle(item);
          });
          item.addEventListener('keydown', event => {
            if (event.target !== item || !['Enter', ' '].includes(event.key)) return;
            event.preventDefault();
            this.toggle(item);
          });
        }
        item.querySelector('[data-color-trigger]')?.addEventListener('click', event => {
          event.stopPropagation();
          this.openDialog(item);
        });
        const dialog = item.querySelector('dialog');
        dialog?.querySelector('[data-dialog-close]')?.addEventListener('click', () => this.closeDialog(item));
        dialog?.addEventListener('click', event => {
          if (event.target === dialog) this.closeDialog(item);
        });
        dialog?.addEventListener('close', () => {
          item.querySelector('[data-color-trigger]')?.setAttribute('aria-expanded', 'false');
          item.querySelector('[data-color-trigger]')?.focus();
        });
        dialog?.querySelectorAll('[data-variant]').forEach(option => {
          option.addEventListener('click', () => {
            this.chooseVariant(item, option);
            this.closeDialog(item);
          });
        });
        item.querySelector('[data-quantity]')?.addEventListener('input', () => this.render());
        item.querySelector('[data-quantity]')?.addEventListener('change', event => {
          event.target.value = String(this.clampQuantity(event.target.value));
          this.render();
        });
        item.querySelector('[data-quantity-minus]')?.addEventListener('click', () => this.changeQuantity(item, -1));
        item.querySelector('[data-quantity-plus]')?.addEventListener('click', () => this.changeQuantity(item, 1));
      });
      this.addButton?.addEventListener('click', () => this.addToCart());
      this.mainVariantInput = document.querySelector('product-form .js-product-form-main input[name="id"]');
      const sync = () => window.setTimeout(() => this.syncMainVariant(), 0);
      document.addEventListener('change', sync);
      document.addEventListener('on:variant:change', sync);
      if (this.mainVariantInput) {
        new MutationObserver(sync).observe(this.mainVariantInput, { attributes: true, attributeFilter: ['value'] });
      }
      this.syncMainVariant();
      this.render();
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: this.currency
      }).format(cents / 100);
    }
    clampQuantity(value) {
      const number = Number.parseInt(value, 10);
      return Number.isFinite(number) ? Math.max(1, Math.min(99, number)) : 1;
    }
    changeQuantity(item, delta) {
      if (this.busy) return;
      const input = item.querySelector('[data-quantity]');
      input.value = String(this.clampQuantity(this.clampQuantity(input.value) + delta));
      this.render();
    }
    syncMainVariant() {
      const main = this.items[0];
      const id = this.mainVariantInput?.value;
      if (!main || !id) return;
      const option = [...main.querySelectorAll('[data-variant]')].find(node => node.dataset.id === id);
      this.mainAvailable = Boolean(option && !option.disabled);
      if (this.mainAvailable && main.dataset.variantId !== id) this.chooseVariant(main, option);
      this.render();
    }
    toggle(item) {
      if (this.busy) return;
      const selected = item.dataset.selected !== 'true';
      item.dataset.selected = String(selected);
      item.classList.toggle('is-selected', selected);
      const checkbox = item.querySelector('[data-select]');
      if (checkbox) checkbox.checked = selected;
      item.setAttribute('aria-label', `${selected ? 'Remove' : 'Select'} ${item.querySelector('.star-b__item-title').textContent.trim()}`);
      if (selected && this.motion) {
        this.animateElement(item, [{transform:'scale(.98)',background:'#e2ebd3'}, {transform:'scale(1.01)',offset:.55}, {transform:'scale(1)',background:'#f7f9f4'}], {duration:400});
        this.animateElement(item.querySelector('.star-b__check'), [{transform:'scale(.7)'},{transform:'scale(1.3)',offset:.6},{transform:'scale(1)'}], {duration:380});
      }
      this.render();
    }
    openDialog(item) {
      const dialog = item.querySelector('dialog');
      if (!dialog || dialog.open) return;
      dialog.showModal();
      item.querySelector('[data-color-trigger]').setAttribute('aria-expanded', 'true');
      if (window.matchMedia('(min-width: 700px)').matches) {
        const box = item.querySelector('[data-color-trigger]').getBoundingClientRect();
        const left = Math.min(Math.max(12, box.left), window.innerWidth - 384);
        const top = Math.min(box.bottom + 8, window.innerHeight - Math.min(600, dialog.scrollHeight) - 12);
        dialog.style.left = `${left}px`;
        dialog.style.top = `${Math.max(12, top)}px`;
      }
      dialog.querySelector('[data-variant]:not(:disabled)')?.focus();
      this.animateElement(dialog, [{opacity:0,transform:window.matchMedia('(max-width:699px)').matches?'translateY(24px)':'translateY(8px) scale(.98)'},{opacity:1,transform:'none'}], {duration:220,easing:'cubic-bezier(.22,.8,.25,1)'});
    }
    closeDialog(item) {
      const dialog = item.querySelector('dialog');
      if (!dialog?.open || dialog.dataset.closing) return;
      if (!this.motion) { dialog.close(); return; }
      dialog.dataset.closing = 'true';
      const animation = this.animateElement(dialog, [{opacity:1,transform:'none'},{opacity:0,transform:'translateY(8px)'}], {duration:140});
      animation.finished.catch(() => {}).finally(() => { dialog.close(); delete dialog.dataset.closing; });
    }
    chooseVariant(item, option) {
      if (option.disabled) return;
      item.dataset.variantId = option.dataset.id;
      item.dataset.variantPrice = option.dataset.price;
      item.querySelector('[data-color-name]').textContent = option.dataset.name;
      item.querySelector('[data-price]').textContent = this.money(Number(option.dataset.price));
      if (item.hasAttribute('data-main')) {
        item.querySelector('[data-included-detail]').textContent = `${option.dataset.name} · ${this.money(Number(option.dataset.price))} each`;
      }
      const image = item.querySelector('.star-b__image');
      if (image && option.dataset.image) {
        image.src = option.dataset.image;
        image.srcset = '';
        image.alt = `${item.querySelector('.star-b__item-title').textContent.trim()} — ${option.dataset.name}`;
      }
      item.querySelectorAll('[data-variant]').forEach(node => node.classList.toggle('is-current', node === option));
      this.render();
    }
    lines() {
      return this.items.flatMap((item, index) => {
        if (index > 0 && item.dataset.selected !== 'true') return [];
        const quantity = this.clampQuantity(item.querySelector('[data-quantity]')?.value);
        return [{ id: Number(item.dataset.variantId), quantity, price: Number(item.dataset.variantPrice) }];
      });
    }
    render() {
      const lines = this.lines();
      const count = lines.reduce((total, line) => total + line.quantity, 0);
      const subtotal = lines.reduce((total, line) => total + line.quantity * line.price, 0);
      const tier = count >= 3 ? 3 : count === 2 ? 2 : 0;
      const discountRate = tier === 3 ? 0.2 : tier === 2 ? 0.15 : 0;
      const savings = Math.round(subtotal * discountRate);
      const offerLive = this.dataset.offerLive === 'true';
      this.querySelector('[data-saving]').textContent = discountRate ? `${offerLive ? 'You save' : 'Potential savings'} ${this.money(savings)}` : 'Your selection';
      this.querySelector('[data-total]').textContent = this.money(offerLive ? subtotal - savings : subtotal);
      this.addButton.textContent = `Add ${count} ${count === 1 ? 'item' : 'items'} to cart`;
      this.items.forEach(item => {
        const input = item.querySelector('[data-quantity]');
        if (!input) return;
        const qty = this.clampQuantity(input.value);
        input.disabled = this.busy;
        item.querySelector('[data-quantity-minus]').disabled = this.busy || qty <= 1;
        item.querySelector('[data-quantity-plus]').disabled = this.busy || qty >= 99;
      });
      const progress = this.querySelector('.star-b__progress');
      progress.setAttribute('aria-valuenow', String(Math.min(3, count)));
      progress.querySelector('span').style.width = `${Math.min(100, count / 3 * 100)}%`;
      this.querySelectorAll('[data-tier]').forEach(node => node.classList.toggle('is-current', Number(node.dataset.tier) === tier));
      this.querySelector('[data-progress-text]').textContent = count >= 3
        ? '20% unlocked'
        : count === 2 ? '15% unlocked · Add 1 for 20%'
          : 'Add 1 item to save 15%';
      this.addButton.disabled = !this.mainAvailable || this.busy;
      if (!this.mainAvailable) this.status.textContent = 'The selected main product color is sold out. Choose an available color.';
      const total = offerLive ? subtotal - savings : subtotal;
      if (this.previousCount !== null && count !== this.previousCount) {
        const firstMaximum = count >= 3 && this.previousCount < 3 && !this.seenTwenty;
        this.showToast(count, savings, firstMaximum);
        if (firstMaximum) {
          this.seenTwenty = true;
          this.animateElement(this.querySelector('[data-tier="3"]'), [{transform:'scale(1)'},{transform:'scale(1.065)',offset:.45},{transform:'scale(1)'}], {duration:600});
        }
      }
      if (this.previousTotal !== null && total !== this.previousTotal) this.animateElement(this.querySelector('[data-total]'), [{opacity:.35,transform:'translateY(6px)'},{opacity:1,transform:'translateY(0)'}], {duration:320});
      this.previousCount = count;
      this.previousTotal = total;
    }
    animateElement(element, frames, options) {
      if (!this.motion || !element) return null;
      const animation = element.animate(frames, options);
      this.animations.add(animation);
      animation.finished.catch(() => {}).finally(() => this.animations.delete(animation));
      return animation;
    }
    showToast(count, savings, celebrate) {
      const toast = this.querySelector('[data-toast]');
      toast.replaceChildren();
      const emblem = document.createElement('strong');
      emblem.className = 'star-b__toast-emblem';
      emblem.textContent = count >= 3 ? '20%' : count === 2 ? '15%' : '✓';
      const words = document.createElement('div');
      const title = document.createElement('strong');
      title.textContent = count >= 3 ? 'Maximum savings unlocked!' : count === 2 ? '15% savings unlocked' : 'Selection updated';
      const detail = document.createElement('span');
      detail.textContent = count >= 2 ? `${this.dataset.offerLive === 'true' ? 'You save' : 'Demo savings:'} ${this.money(savings)} on this bundle` : 'Add one more item to unlock 15%';
      words.append(title, detail);
      toast.append(emblem, words);
      toast.hidden = false;
      this.animateElement(toast, [{opacity:0,transform:'translate(-50%,-18px) scale(.94)'},{opacity:1,transform:'translate(-50%,3px) scale(1.015)',offset:.7},{opacity:1,transform:'translate(-50%,0) scale(1)'}], {duration:480,easing:'cubic-bezier(.22,.8,.25,1)'});
      if (celebrate && this.motion) {
        const cloud = document.createElement('span');
        cloud.className = 'star-b__stars';
        cloud.setAttribute('aria-hidden', 'true');
        toast.append(cloud);
        for (let i = 0; i < 24; i++) {
          const star = document.createElement('i');
          star.textContent = i % 3 === 0 ? '✦' : '·';
          star.style.color = i % 2 ? '#344415' : '#b29350';
          cloud.append(star);
          const angle = i / 24 * Math.PI * 2, distance = 65 + (i % 4) * 22;
          this.animateElement(star, [{transform:'translate(0,0) scale(.3)',opacity:0},{opacity:1,offset:.15},{transform:`translate(${Math.cos(angle)*distance}px,${Math.sin(angle)*distance+25}px) rotate(${i*25}deg) scale(1.4)`,opacity:0}], {duration:1400,easing:'cubic-bezier(.2,.6,.3,1)'});
        }
        window.setTimeout(() => cloud.remove(), 1500);
      }
      window.clearTimeout(this.toastTimer);
      this.toastTimer = window.setTimeout(() => { toast.hidden = true; toast.replaceChildren(); }, count >= 3 ? 3400 : 2200);
    }
    async addToCart() {
      if (this.busy) return;
      this.syncMainVariant();
      if (!this.mainAvailable) return;
      const lines = this.lines();
      if (!lines.length || lines.some(line => !Number.isSafeInteger(line.id) || line.quantity < 1)) {
        this.status.textContent = 'Please select an available color and quantity.';
        return;
      }
      this.busy = true;
      this.addButton.disabled = true;
      this.addButton.setAttribute('aria-busy', 'true');
      this.status.textContent = 'Adding selected pieces…';
      const originalLabel = this.addButton.textContent;
      this.addButton.textContent = 'Adding…';
      const root = window.Shopify?.routes?.root || '/';
      const cartDrawer = document.querySelector('cart-drawer');
      const drawerSection = cartDrawer?.closest('.shopify-section')?.id?.replace('shopify-section-', '');
      const sections = ['cart-icon-bubble', drawerSection].filter(Boolean);
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: lines.map(({ id, quantity }) => ({ id, quantity })),
            sections,
            sections_url: window.location.pathname
          })
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || 'Unable to update the cart.');
        }
        this.status.textContent = 'Added to cart. Review the final price in your cart.';
        this.addButton.textContent = 'Added to cart';
        if (cartDrawer && result.sections?.[drawerSection] && result.sections?.['cart-icon-bubble']) {
          try {
            await cartDrawer.renderContents(result, true);
          } catch (_) {
            window.location.assign(`${root}cart`);
          }
        } else window.location.assign(`${root}cart`);
      } catch (error) {
        this.status.textContent = error.message || 'Could not add these pieces. Please try again.';
        this.addButton.textContent = originalLabel;
      } finally {
        this.busy = false;
        this.addButton.disabled = false;
        this.addButton.removeAttribute('aria-busy');
        if (this.addButton.textContent === 'Added to cart') {
          window.setTimeout(() => { this.addButton.textContent = originalLabel; }, 2300);
        }
      }
    }
  });
}
